import React from "react";
import PackageDetails from "./PackagesDetails";
import investImg from "../../assets/invest-img.png";
import savestimg from "../../assets/savest-img.jpg";
import refer from "../../assets/refer.png";
import arrow from "../../assets/footer-arrow.png";
import { Link } from "react-router-dom";

const PackageWrap = () => {
  return (
    <div style={{}}>
      <PackageDetails
        style={{
          color: "#fd740e",
        }}
        title={"Investments"}
        image={investImg}
        body={
          "Invest in low risk and earn up to 15% at the end of each 30 business days "
        }
      />
      <PackageDetails
        style={{
          color: "#281bb6",
        }}
        title={"Create a Savest plan"}
        image={savestimg}
        body={"Save as a tribe and earn up to 7% every 30 days"}
      />

      <Link to="/dashboard/referral">
        <PackageDetails
          style={{
            backgroundColor: "#eaf7f3",
            color: "#08990d",
          }}
          title={"Refer & Earn"}
          image={refer}
          body={"Get rewarded when friends signup & invest"}
          footer={"Refer a Friend"}
          footerIcon={arrow}
        />
      </Link>
    </div>
  );
};

export default PackageWrap;
